import React, { Component } from 'react';
import WaveSurfer from 'wavesurfer.js';
import MicRecorder from 'mic-recorder-to-mp3';
import axios from 'axios';

const Mp3Recorder = new MicRecorder({ bitRate: 128 });

class AudioRecorder extends Component {
	  
	constructor(props) {
		super(props);
		this.state = {
			isRecording: false,
			blobURL: '',
			transcription: '',
			timer: 0,
			waveSurfer: null,
			isPlaying: false,
		};
		this.audioRef = React.createRef();
	}
	
	interval = null; 

	componentDidMount() {
		const waveSurfer = WaveSurfer.create({
			container: '#waveform',
			waveColor: 'lightblue',
			progressColor: 'royalblue',
			backend: 'MediaElement',
			mediaControls: true,
			height: 50
		});
		this.setState({ waveSurfer });
	}
	
	formatTime = (seconds) => {
	  //const hrs = String(Math.floor(seconds / 3600)).padStart(2, '0');
	  const mins = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
	  const secs = String(seconds % 60).padStart(2, '0');
	  //return `${hrs}:${mins}:${secs}`;
	  return `${mins}:${secs}`;
	}

	startRecording = () => {
		Mp3Recorder
		  .start()
		  .then(() => {
			this.setState({ isRecording: true, timer: 0 });
			this.interval = setInterval(() => {
			  this.setState(prevState => ({ timer: prevState.timer + 1 }));
			}, 1000);
		  })
		  .catch(e => console.error(e));
	}

	stopRecording = () => {
		Mp3Recorder
		.stop()
		.getMp3()
		.then(([buffer, blob]) => {
			const blobURL = URL.createObjectURL(blob);
			//const blobURL = 'https://api.twilio.com//2010-04-01/Accounts/AC25aa00521bfac6d667f13fec086072df/Recordings/RE6d44bc34911342ce03d6ad290b66580c.mp3';
			const { waveSurfer } = this.state;
			waveSurfer.load(blobURL);
			this.setState({ blobURL, isRecording: false });
			clearInterval(this.interval);
			this.transcribeAudio(blob);
		})
		.catch(e => console.log(e));
	}

	/* transcribeAudio = async (blob) => {
		const formData = new FormData();
		formData.append('file', blob, 'audio.wav');
		formData.append('model', 'whisper-1');

		try {
		  // Use Axios to send the audio to Whisper API
		  const response = await axios.post('https://api.openai.com/v1/audio/transcriptions', formData, {
			headers: {
			  'Authorization': `Bearer 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`,
			  'Content-Type': 'multipart/form-data',
			},
		  });

		  // Set transcription in the state
		  this.setState({ transcription: response.data.text || 'No transcription found!'  });
		} catch (error) {
		  console.error('Error transcribing audio:', error);
		}
	} */
	
	transcribeAudio = async (blob) => {
		try {
			const response = await fetch('https://api.deepgram.com/v1/listen', {
			  method: 'POST',
			  headers: {
				'Authorization': 'Token c4e76b1c347616878ca83a1160fd0f52c0eb545a',
				'Content-Type': 'audio/mp3',
			  },
			  body: blob,
			});

			const result = await response.json();
			const transcript = result.results?.channels[0]?.alternatives[0]?.transcript;

			this.setState({ transcription: transcript || 'No transcription found' });
		} catch (error) {
			console.error('Transcription failed', error);
			this.setState({ transcription: 'Error during transcription' });
		}
	}
  

	togglePlay = () => {
		const audio = this.audioRef.current;
		if (this.state.isPlaying) {
		  audio.pause();
		} else {
		  audio.play();
		}
		this.state.waveSurfer.playPause()
		this.setState((prevState) => ({
		  isPlaying: !prevState.isPlaying,
		}));
	}

  render() {
    const { isRecording, blobURL, transcription, timer } = this.state;
	let time = '--:--';
	if(timer > 0){
		time = this.formatTime(timer);
	}
    return (
      <div style={{maxWidth: '600px' }}>
        <div className="audio-recorder">
		<p>{time}</p>
		
		{isRecording ?
			<button className="btn btn-danger btn-record" onClick={this.stopRecording}><i className="fa fa-stop-circle" aria-hidden="true"></i> Stop Recording</button>
		:
			<button className="btn btn-primary btn-record" onClick={this.startRecording}><i className="fa fa-dot-circle-o" aria-hidden="true"></i> Start Recording</button>
		}
		</div>
        
		{blobURL ?
			<div id="waveform" style={{ marginTop: '20px', height: '100px' }}></div>
		:
			<div id="waveform" style={{ display: 'none'}}></div>
		}
		
        {/* blobURL && (
          <div>
            <h3>Playback</h3>
            <audio ref={this.audioRef} src={blobURL} controls />
			<button onClick={this.togglePlay} className="play-button">
			  {this.state.isPlaying ? 'Pause' : 'Play'}
			</button>
          </div>
        ) */}

        {transcription && (
          <div>
            <h3>Transcription</h3>
            <p>{transcription}</p>
          </div>
        )}
      </div>
    );
  }
}

export default AudioRecorder;
